import MUIMenu from "@material-ui/core/Menu";

const Menu = ({ children, ...otherProps }) => {
  return <MUIMenu {...otherProps}>{children}</MUIMenu>;
};

export default Menu;
